var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","flex":"1"}},[_c('svg',{ref:"mapbox",attrs:{"id":"map"},on:{"dblclick":_vm.svgClick}}),_c('div',{attrs:{"id":"tootip"}})])}
var staticRenderFns = []

export { render, staticRenderFns }